(function () {
    'use strict';

    angular.module("imApp").factory("orderDeliveryInfoService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1909,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
